<template>
    <div v-if="promotions !== null && discountBarVisible && currentPromotionProduct" class="discount-bar-special">
      <a class="close-btn" href="javascript:" @click="closeWindow">
        <i class="fa fa-times"></i>
      </a>
      <b class="on-sale-label">{{ currentPromotionProduct?.discount_desc }}</b>UP TO 45% OFF<br>
      <CountDownTimer :endDate="promotionEndDate" />
      <NuxtLink v-if="!isCurrentRoute" to="/sales/cyber-monday-sale" class="fa-btn fa-btn-complementary" style="">Check it out</NuxtLink>
    </div>   
  <div v-if="0 && promotions !== null && discountBarVisible && currentPromotionProduct" class="discount-bar">
    <a class="close-btn" href="javascript:" @click="closeWindow">
      <i class="fa fa-times"></i>
    </a>
    <div id="discount-grid">
      <div id="discount-showcase">
        <NuxtLink :to="dataStore.getProductSlug(item.name)">
          <Showcase 
            :mediaId="currentPromotionProduct?.showcaseId"
            icon="shop"
            :discount="currentPromotionProduct.total_discount"
            />
        </NuxtLink>
      </div>
      <div id="discount-product">
        <div id="discount-product-data">
          <b class="on-sale-label">{{ currentPromotionProduct?.discount_desc }}</b><br>
          <NuxtLink class="discount-item-name" :to="dataStore.getProductSlug(item.name)">{{ currentPromotionProduct?.name }}</NuxtLink><br>
          <s>{{ userStore.formatPriceForUser(currentPromotionProduct?.price) }}</s>
          <b id="discount-price">{{ userStore.formatPriceForUser(currentPromotionProduct?.discounted_price) }}</b>
        </div>
        <div id="third-row">
          <div v-html="currentPromotionProduct.shopDesc" id="discount-product-description"></div>
          <div id="discount-product-link">
            <CountDownTimer :endDate="promotionEndDate" />
            <a @click="addItemToCart(item.name)" class="fa-btn fa-btn-complementary" style="margin-top: 1rem;">Buy now!</a>
          </div>
        </div>
        
      </div>
    </div>
  </div>    
</template>

<script setup>
import { ref, onMounted, computed, onBeforeUnmount } from 'vue';
import { useRoute } from 'vue-router';
import { useDataStore } from '~/store/dataStore';

const bundles = computed(() => dataStore.products?.bundle);
const pluginData = computed(() => dataStore.products.plugin);
const samplepackData = computed(() => dataStore.products.samplepack);
import { useUserStore } from '@/store/userStore';

const route = useRoute();
const isCurrentRoute = computed(() => route.path === '/products/guitar-cabinet-impulse-responses');

let checkEndDateInterval;  // Declare an interval variable

const userStore = useUserStore();

const allProducts = computed(() => [...pluginData.value, ...samplepackData.value, ...bundles.value]);

import { useCartStore } from '~/store/cartStore';

const cartStore = useCartStore();
const addItemToCart = (item) => cartStore.addToCart(item);

const dataStore = useDataStore();
const promotions = ref(null);
const discountBarVisible = ref(true);
const currentPromotionProduct = ref(null);
const promotionEndDate = ref(null);

onMounted(() => {
  
  dataStore.fetchProductData().then(() => {
    dataStore.fetchPromotions().then(() => {
    
    promotions.value = dataStore?.promotions?.result?.products || null;
    console.log(promotions.value, "Promotions");
    console.log("Promotions:", promotions.value);
    setCurrentPromotionProduct();
    if(currentPromotionProduct.value || !sessionStorage.getItem('discountBarClosed')) {
      discountBarVisible.value = true;
    }
  });
  });
});

const setCurrentPromotionProduct = () => {
  if (!promotions.value?.length) return;

  // Randomly select a promotion
  const randomIndex = Math.floor(Math.random() * promotions.value.length);
  const selectedPromotion = promotions.value[randomIndex];

  if (selectedPromotion?.end_date) {
    promotionEndDate.value = new Date(selectedPromotion.end_date);
        // Start the interval here
    checkEndDateInterval = setInterval(() => {
      if (new Date() > promotionEndDate.value) {
        discountBarVisible.value = false;
        dataStore.fetchProductData(true);
      }
    }, 1000); // Check every second
  }

  console.log("Selected promotion:", selectedPromotion);

  if (!selectedPromotion?.product_name) return;

  const foundProduct = allProducts.value.find(product => product.name === selectedPromotion.product_name);

  if (foundProduct) {
    currentPromotionProduct.value = {
      ...foundProduct,
      discount_desc: selectedPromotion.description // Add the description here
    };
  } else {
    currentPromotionProduct.value = null;
  }

  console.log("Found product:", currentPromotionProduct.value);
};


const closeWindow = () => {
  discountBarVisible.value = !discountBarVisible.value;
  sessionStorage.setItem('discountBarClosed', 'true');
};

// You seem to have a "checkOut" method in the template, but it was not defined in the script.
// Define it if necessary.
const checkOut = () => {
  if(!currentPromotionProduct.value) return;
  buyNowSingle(currentPromotionProduct.value.name);
};

onBeforeUnmount(() => {
  clearInterval(checkEndDateInterval); // Clear the interval when the component is destroyed
});


</script>

<style scoped lang="scss">
@import '~/assets/constants.scss';
.discount-bar-special {
  display: flex;
  background: radial-gradient(circle at top left, $fa-orange, $fa-dark-orange);
  color: $light-white;
  z-index: 995;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  gap: 1.5rem;
}
.discount-bar {
  background: radial-gradient(circle at top left, $fa-orange, $fa-dark-orange);
  color: $light-white;
  z-index: 995;
  position: relative;
}

.discount-item-name {
  font-size: 1.35rem;
  font-weight: bold;
}

.on-sale-label
{
  font-size: 1.5rem;
}

#discount-product {
  display: flex;
}

#discount-grid {
  display: grid;
  grid-template-columns: 33% 67%;
  padding: 1.5rem;
  padding-left: 5rem;
  padding-right: 5rem;
}

#discount-product-data {
  padding: 1.5rem;
  padding-top: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#discount-product-description {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.5rem;
  font-size: 1.15rem;
}

#discount-product-link {
  padding-left: 1.5rem;
}

#discount-price {
  font-size: 1.5rem; 
  font-weight: bold;
}

@media (max-width: 481px) {
  .discount-bar {
    display: none;
  }
}

@media (min-width: 481px) and (max-width: 768px) {
  #discount-showcase {
    width: 35vw !important;
  }
}

@media (max-width: 1024px) {
  #discount-product-description {
    display: none !important;
  }

  #discount-grid {
    padding: 0.75rem !important;
    justify-content: center;
    align-content: center;
    grid-template-columns: inherit !important;
    display: flex !important;
  }

  #discount-showcase {
    width: 25vw;
  }

  #discount-product-data {
    font-size: 1rem;
  }
}
</style>